import React, { FunctionComponent } from 'react'

const TabBar: FunctionComponent = ({ children }) => (
  <div className="w-full">
    <nav className=" w-full justify-start items-center flex space-x-1">{children}</nav>
  </div>
)

export default TabBar
